






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import {
  IDate,
  AgentTypeEnum,
  CountryEnum,
  LanguageEnum,
  ProductTypeEnum,
} from '@/api/types';
import {
  api_agent,
  get_agent,
  put_agent,
  listAgentSummaries,
  getAgent,
  putAgent,
} from '@/api/agent';
import { list_product_summaries, listProductSummaries } from '@/api/product';
import {
  formatApiError,
  stringFromIDate,
  stringToIDate,
  monthStringFromIDate,
  stringToNumber,
  compareString,
} from '@/utils/index';
import { newDefaultAgent } from '@/utils/agent';
import { productById } from '@/utils/product';
import { translateRouteTitle } from '@/utils/permission';
import { validEmail } from '@/utils/validation';

type ItemType = {
  text: string;
  value: string;
};

type WithEditingOptions = {
  contractSendDateStr: string;
  contractReceiveDateStr: string;
  contractDeliveryDateStr: string;
};

@Component({
  name: 'AgentCreate',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private loading = true;
  private valid = false;
  private editingAgent = {} as api_agent.Agent & WithEditingOptions;
  private agentTypeItems: ItemType[] = [];
  private countryItems: ItemType[] = [];
  private allAgentCountries: {
    [country: string]: string;
  } = {};
  private languageItems: ItemType[] = Object.freeze(
    Object.values(LanguageEnum).map(c => ({
      text: c,
      value: c,
    }))
  ) as ItemType[];
  private allProducts: Map<string, list_product_summaries.Product> = new Map();
  private contractProductItems: ItemType[] = [];
  private contractSendDateMenu = false;
  private contractReceiveDateMenu = false;
  private contractDeliveryDateMenu = false;
  private createdAgentId = '';
  private redirectAfterCreate = true;
  private showRedirectAfterCreate = true;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private showCopyAgents = false;
  private canCopyAgents = false;
  private copyAgentId = '';
  private agentItems: ItemType[] = [];

  get appLanguage() {
    return AppModule.language;
  }

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canModifyAgentType() {
    return true;
  }

  get contractProductStatusFalseValue() {
    return api_agent.Status.OFF;
  }

  get contractProductStatusTrueValue() {
    return api_agent.Status.ON;
  }

  get canAddContractProduct() {
    return (
      this.editingAgent &&
      this.editingAgent.contractProducts &&
      this.editingAgent.contractProducts.length !== this.allProducts.size
    );
  }

  get canShowGdsOtaIdUsernamePassword() {
    return (
      (this.editingAgent.type as AgentTypeEnum) ===
        AgentTypeEnum.OVERSEAS_BUYOUT ||
      (this.editingAgent.type as AgentTypeEnum) ===
        AgentTypeEnum.DOMESTIC_BUYOUT
    );
  }

  get canShowOrderAmountLimit() {
    return (
      (this.editingAgent.type as AgentTypeEnum) ===
        AgentTypeEnum.OVERSEAS_BUYOUT ||
      (this.editingAgent.type as AgentTypeEnum) ===
        AgentTypeEnum.DOMESTIC_BUYOUT
    );
  }

  get canCreate() {
    return this.valid;
  }

  created() {
    this.reset();
  }

  mounted() {
    this.loadAgentTypeItems();
    this.loadProducts();
    this.fetchData();
  }

  @Watch('appLanguage')
  private onLangSelected() {
    this.loadCountryItems();
    this.loadContractProductItems();
    (this.$refs.form as any).resetValidation();
  }

  private loadCountryItems() {
    this.countryItems = Object.values(CountryEnum)
      .map(c => ({
        text: `${this.$t('CountryEnum.' + c)}(${c})`,
        value: c,
      }))
      .sort((c1, c2) =>
        this.allAgentCountries[c1.value]
          ? this.allAgentCountries[c2.value]
            ? compareString(c1.value, c2.value)
            : -1
          : this.allAgentCountries[c2.value]
          ? 1
          : compareString(c1.value, c2.value)
      ) as ItemType[];
  }

  private loadAgentTypeItems() {
    this.agentTypeItems = Object.values(AgentTypeEnum)
      .filter(t => (t as AgentTypeEnum) !== AgentTypeEnum.UNKNOWN_AGENT_TYPE)
      .map(t => ({
        text: this.$t(`AgentTypeEnum.${t}`) as string,
        value: t,
      }));
  }

  private async loadProducts() {
    this.loading = true;
    AppModule.StartProgress();

    const listProductsRes = await listProductSummaries({
      types: Object.values(ProductTypeEnum).filter(
        t => (t as ProductTypeEnum) !== ProductTypeEnum.UNKNOWN_PRODUCT_TYPE
      ),
      includeInactive: true,
    } as list_product_summaries.Request);
    this.allProducts = Object.freeze(
      productById(listProductsRes.products)
    ) as Map<string, list_product_summaries.Product>;
    this.loadContractProductItems();

    AppModule.StopProgress();
    this.loading = false;
  }

  private loadContractProductItems() {
    this.contractProductItems = Object.freeze(
      Array.from(this.allProducts.values()).map(p => ({
        text: `[${this.$t('ProductTypeEnum.' + p.type)}] ${this.getProductName(
          p.id
        )}`,
        value: p.id,
      }))
    ) as ItemType[];
  }

  private async fetchThenLoadAllAgentCountries() {
    try {
      const res = await listAgentSummaries({ agentTypes: [] });
      this.allAgentCountries = { dummy: 'dummy' };
      res.agentSummaries.forEach(a => {
        this.allAgentCountries[a.country] = a.country;
      });
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async fetchData(noLoading = false) {
    this.loading = true;
    AppModule.StartProgress();

    await this.fetchThenLoadAllAgentCountries();
    this.loadCountryItems();

    AppModule.StopProgress();
    this.loading = false;
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.showRedirectAfterCreate = true;
    this.showCopyAgents = false;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCreate() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = true;
    this.showCopyAgents = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.createAgent();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyAgents = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private async showDialogForCopy() {
    await this.fetchThenLoadAgents();
    this.dialogTextTitle = `${this.$t('Copy from other {msg}', {
      msg: this.$t('Agent'),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyAgents = true;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.copyAgent();
    };
    this.dialog = true;
  }

  private async fetchThenLoadAgents() {
    if (this.agentItems.length === 0) {
      try {
        const res = await listAgentSummaries({
          agentTypes: Object.values(AgentTypeEnum),
        });
        this.agentItems = res.agentSummaries.map(a => ({
          text: a.name,
          value: a.id,
        }));
      } catch (err) {
        this.$toast.error(
          this.$t('Failed to {do} due to {err}', {
            do: (this.$t('Fetch {msg}', {
              msg: this.$t('Account'),
            }) as string).toLowerCase(),
            err: formatApiError(this.$i18n, err),
          }) as string,
          {
            icon: 'mdi-alert',
          }
        );
      }
    }
  }

  private async copyAgent() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const res = await getAgent({ agentId: this.copyAgentId });
      this.editingAgent = JSON.parse(
        JSON.stringify(res.agent)
      ) as api_agent.Agent & WithEditingOptions; // naive deep copy implemantaion
      res.agent.orderAmountLimit || (this.editingAgent.orderAmountLimit = {});
      this.editingAgent.contractSendDateStr = stringFromIDate(
        res.agent.contractSendDate
      )!;
      this.contractSendDateMenu = false;
      this.editingAgent.contractReceiveDateStr = stringFromIDate(
        res.agent.contractReceiveDate
      )!;
      this.contractReceiveDateMenu = false;
      this.editingAgent.contractDeliveryDateStr = stringFromIDate(
        res.agent.contractDeliveryDate
      )!;
      this.contractDeliveryDateMenu = false;
      res.agent.remarks || (this.editingAgent.remarks = '');
      res.agent.gdsOtaId || (this.editingAgent.gdsOtaId = '');
      res.agent.gdsOtaUsername || (this.editingAgent.gdsOtaUsername = '');
      res.agent.gdsOtaPassword || (this.editingAgent.gdsOtaPassword = '');
      delete this.editingAgent.id;
      delete this.editingAgent.version;
      this.editingAgent.name = '';
      this.editingAgent.alias = [];
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private validate(): boolean {
    return (this.$refs.form as any).validate();
  }

  private resetValidation() {
    (this.$refs.form as any).resetValidation();
  }

  private reset() {
    this.editingAgent = newDefaultAgent() as api_agent.Agent &
      WithEditingOptions;
    this.editingAgent.contractSendDateStr = stringFromIDate(
      this.editingAgent.contractSendDate
    )!;
    this.contractSendDateMenu = false;
    this.editingAgent.contractReceiveDateStr = stringFromIDate(
      this.editingAgent.contractReceiveDate
    )!;
    this.contractReceiveDateMenu = false;
    this.editingAgent.contractDeliveryDateStr = stringFromIDate(
      this.editingAgent.contractDeliveryDate
    )!;
    this.contractDeliveryDateMenu = false;
  }

  private addEditingAlias() {
    this.editingAgent.alias.push('');
  }

  private removeEditingAlias(aliasIndex: number) {
    this.editingAgent.alias.splice(aliasIndex, 1);
  }

  private addEditingContractProduct() {
    const product = Array.from(this.allProducts.values()).filter(p =>
      this.editingAgent.contractProducts.every(
        contractProduct => contractProduct.productId !== p.id
      )
    )[0];
    this.editingAgent.contractProducts.push({
      productId: product.id,
      status: api_agent.Status.ON,
      commissionRatePercent: 0,
    });
  }

  private removeEditingContractProduct(contractProductIndex: number) {
    this.editingAgent.contractProducts.splice(contractProductIndex, 1);
  }

  private addEditingContact() {
    this.editingAgent.contacts.push({
      name: '',
      department: '',
      position: '',
      phoneNumber: '',
      faxNumber: '',
      emailAddress: '',
    });
  }

  private removeEditingContact(contactIndex: number) {
    this.editingAgent.contacts.splice(contactIndex, 1);
  }

  private addEditingBillingReceiver() {
    this.editingAgent.billingReceivers.push({
      name: '',
      department: '',
      position: '',
      phoneNumber: '',
      faxNumber: '',
      emailAddress: '',
    });
  }

  private removeEditingBillingReceiver(contactIndex: number) {
    this.editingAgent.billingReceivers.splice(contactIndex, 1);
  }

  private addEditingShippingReceiver() {
    this.editingAgent.shippingReceivers.push({
      name: '',
      department: '',
      position: '',
      phoneNumber: '',
      faxNumber: '',
      emailAddress: '',
    });
  }

  private removeEditingShippingReceiver(contactIndex: number) {
    this.editingAgent.shippingReceivers.splice(contactIndex, 1);
  }

  private async createAgent() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const newAgent = JSON.parse(
        JSON.stringify(this.editingAgent)
      ) as api_agent.Agent & WithEditingOptions;
      delete newAgent.isGdsAccountValid;
      delete newAgent.balanceCreditAmount;
      delete newAgent.balanceCredits;
      if (
        (newAgent.type as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_AGENCY ||
        (newAgent.type as AgentTypeEnum) === AgentTypeEnum.EXCHANGE_STATION
      ) {
        delete newAgent.gdsOtaId;
        delete newAgent.gdsOtaUsername;
        delete newAgent.gdsOtaPassword;
      }
      if (newAgent.orderAmountLimit) {
        if ((newAgent.orderAmountLimit.min as any) === '') {
          delete newAgent.orderAmountLimit.min;
        }
        if ((newAgent.orderAmountLimit.max as any) === '') {
          delete newAgent.orderAmountLimit.max;
        }
        if ((newAgent.orderAmountLimit.step as any) === '') {
          delete newAgent.orderAmountLimit.step;
        }
      }
      delete newAgent.contractSendDateStr;
      delete newAgent.contractReceiveDateStr;
      delete newAgent.contractDeliveryDateStr;
      if (!newAgent.remarks) {
        delete newAgent.remarks;
      }

      const res = await putAgent({
        agent: newAgent,
      } as put_agent.Request);
      this.createdAgentId = res.agentId;
      await this.postCreate(res.agentId);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      await this.postCreate();
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private async postCreate(agentId?: string) {
    if (this.redirectAfterCreate && agentId) {
      this.$nextTick(() => {
        this.$router.push(`/agent/${agentId}`);
      });
    } else {
      this.reset();

      if (agentId) {
        this.createdAgentId = agentId;

        this.$toast.success(
          this.$t('Succeeded {do}', {
            do: (this.translateRouteTitle(
              this.$route.meta.title
            ) as string).toLowerCase(),
          }) as string,
          {
            icon: this.$route.meta.icon,
          }
        );
      }
    }
  }

  private stringIsNumber(v?: string) {
    return v !== void 0 && !isNaN(stringToNumber(v));
  }

  private getRequiredRules(
    msg: string,
    exception: (v: any) => boolean = () => false
  ) {
    return [
      (v: string) =>
        exception(v) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t(msg),
        }) as string),
    ];
  }

  private getMinRules(
    msg: string,
    min?: number,
    exception: (v: any, min: any) => boolean = () => false
  ) {
    return [
      (v: number) =>
        exception(v, min) ||
        v >= min! ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t(msg),
          num: min,
        }) as string),
    ];
  }

  private getMaxRules(
    msg: string,
    max?: number,
    exception: (v: any, max: any) => boolean = () => false
  ) {
    return [
      (v: number) =>
        exception(v, max) ||
        v <= max! ||
        (this.$t('{msg} must be equal or less than {num}', {
          msg: this.$t(msg),
          num: max,
        }) as string),
    ];
  }

  private getNotRequiredEmailRules() {
    return [
      (v: string) =>
        !v ||
        validEmail(v) ||
        (this.$t('Invalid {msg}', {
          msg: this.$t('Email'),
        }) as string),
    ];
  }

  private getProductName(productId: string) {
    if (this.allProducts.has(productId)) {
      return `${
        this.$i18n.locale !== 'ja' && this.allProducts.get(productId)!.nameEn
          ? this.allProducts.get(productId)!.nameEn
          : this.allProducts.get(productId)!.name
      }${
        this.allProducts.get(productId)!.fiscalYear === 0
          ? ''
          : ' [' + this.allProducts.get(productId)!.fiscalYear + ']'
      }`;
    }
    return '';
  }

  private shouldShowProductCommission(productId: string) {
    if (this.allProducts.has(productId)) {
      return (
        (this.allProducts.get(productId)!.type as ProductTypeEnum) !==
        ProductTypeEnum.FREE_MATERIAL
      );
    }
    return false;
  }

  private isContractProductOn(status: api_agent.Status) {
    return (status as api_agent.Status) === api_agent.Status.ON;
  }

  private stringFromIDate(date: IDate) {
    return stringFromIDate(date)!;
  }

  private stringToIDate(dateStr: string) {
    return stringToIDate(dateStr)!;
  }

  private handleContractSendDateInput() {
    this.contractSendDateMenu = false;
    this.editingAgent.contractSendDate = stringToIDate(
      this.editingAgent.contractSendDateStr
    )!;
  }

  private handleContractReceiveDateInput() {
    this.contractReceiveDateMenu = false;
    this.editingAgent.contractReceiveDate = stringToIDate(
      this.editingAgent.contractReceiveDateStr
    )!;
  }

  private handleContractDeliveryDateInput() {
    this.contractDeliveryDateMenu = false;
    this.editingAgent.contractDeliveryDate = stringToIDate(
      this.editingAgent.contractDeliveryDateStr
    )!;
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
